import { MenuList, type MenuListProps } from '@chakra-ui/react';

export type UiMenuListProps = MenuListProps;

export const UiMenuList = MenuList;
